<template>
  <!-- 费用报销详情 -->
  <div>
    <div class="titleText">
      费用报销单（{{formData.id}}）
      <div v-hasPermission="'reimbursement:export'" class="dy" @click="ClickExProt">
        <a-icon type="printer" theme="filled" style="fontSize: 16px;" />打印
      </div>
    </div>
    <div>
      <a-row type="flex" justify="space-between" style="margin: 10px 0;padding:0 10px;">
        <a-col :span="8">
          <b>报销主题:</b>
          {{formData.subject}}
        </a-col>
        <a-col :span="8">
          <b>申请日期:</b>
          {{formData.reimbursementDate}}
        </a-col>
        <a-col :span="4" style="text-align:right;">
          <b>申请人:</b>
          {{formData.peopleName}}
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-table
            :data-source="tableDataSource"
            :columns="tableColumns"
            :pagination="false"
            :rowKey="(record,index)=>{return index}"
            size="small"
            bordered
          >
            <template slot="status" slot-scope="text, record">
              <a-tooltip>
                <template
                  slot="title"
                >{{ record.status === 0 || record.status === null ? '' : '当前大额申请日期晚于费用报销日期！' }}</template>
                <a-icon
                  v-if="record.status !== 0 && record.status !== null"
                  type="exclamation-circle"
                  style="color: #f79c3a;"
                />
              </a-tooltip>
            </template>
            <template slot="costType" slot-scope="text, record">
              <span>{{costTypeObj[record.costType]}}</span>
            </template>
            <template slot="amount" slot-scope="text, record">
              <span>{{parseFloat(record.amount).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </template>
            <template slot="bigAmountId" slot-scope="text, record">
              <span
                style="color:#1890ff; margin-right: 10px; cursor: pointer;"
                @click="goBigamount(record)"
              >{{record.bigamountId}}</span>
            </template>
          </a-table>
          <div class="sumDiv">
            <div>
              <span class="sumTitle">共{{tableDataSource ? tableDataSource.length : 0}}条，</span>
              <span class="sumTitle">合计:</span>
              {{parseFloat(formData.amount).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}元
            </div>
            <div>
              <span class="sumTitle">金额大写:</span>
              {{ dealBigMoney(formData.amount) }}
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px;">
        <b style="padding: 10px;">发票明细:</b>
        <a-col :span="24">
          <a-table
            :data-source="invoiceDataSource"
            :columns="invoiceColumns"
            :pagination="false"
            :rowKey="(record,index)=>{return index}"
            size="small"
            bordered
          >
            <template slot="fileName" slot-scope="text, record">
              <a-tooltip placement="topLeft">
                <template slot="title">{{record.fileName}}</template>
                <a :href="baseURL + record.fileUrl" target="_blank">{{record.fileName}}</a>
              </a-tooltip>
            </template>
            <template slot="money" slot-scope="text, record">
              <span>{{parseFloat(record.money).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </template>
          </a-table>
        </a-col>
      </a-row>
    </div>
    <div style="margin: 30px 0 20px 0;">
      <audit-process-vue ref="auditRef" />
    </div>
    <div style="margin-top: 20px;padding: 0 8px;">
      <a-row class="rowStyle">
        <a-col :span="2" class="content_col">
          <b>对应项目:</b>
        </a-col>
        <a-col
          :span="16"
          class="onClickStyle"
          @click="isProject(formData, 'project')"
        >{{formData.project}}</a-col>
      </a-row>
      <a-row class="rowStyle">
        <a-col :span="2" class="content_col">
          <b>对应销售机会:</b>
        </a-col>
        <a-col
          :span="16"
          class="onClickStyle"
          @click="isProject(formData, 'salesOpportunities')"
        >{{formData.opportunityTitle}}</a-col>
      </a-row>
      <a-row class="rowStyle">
        <a-col :span="2" class="content_col">
          <b>对应客户:</b>
        </a-col>
        <a-col
          :span="16"
          class="onClickStyle"
          @click="isProject(formData, 'customerName')"
        >{{formData.customerName}}</a-col>
      </a-row>
      <a-row class="rowStyle">
        <a-col :span="12">
          <a-col :span="4" class="content_col">
            <b>有票金额:</b>
          </a-col>
          <a-col :span="10">{{formData.amountTickets}}</a-col>
        </a-col>
        <a-col :span="12">
          <a-col :span="4" class="content_col">
            <b>无票金额:</b>
          </a-col>
          <a-col :span="10">{{formData.amountNoTickets}}</a-col>
        </a-col>
      </a-row>
      <a-row class="rowStyle">
        <a-col :span="12">
          <a-col :span="4" class="content_col">
            <b>缺票金额:</b>
          </a-col>
          <a-col :span="10">{{formData.amountLackTickets}}</a-col>
        </a-col>
        <a-col :span="12">
          <a-col :span="4" class="content_col">
            <b>补票金额:</b>
          </a-col>
          <a-col :span="10">{{formData.amountReplacementTicket}}</a-col>
        </a-col>
      </a-row>
      <a-row class="rowStyle">
        <a-col :span="2" class="content_col">
          <b>项目负责人:</b>
        </a-col>
        <a-col :span="16">{{dutyPersonObj[formData.dutyPerson]}}</a-col>
      </a-row>
      <a-row class="rowStyle">
        <a-col :span="2" class="content_col">
          <b>备注:</b>
        </a-col>
        <a-col :span="16">{{formData.remark}}</a-col>
      </a-row>
      <a-row class="rowStyle">
        <a-col :span="2" class="content_col">
          <b>抄送人:</b>
        </a-col>
        <a-col :span="16">{{formData.userName}}</a-col>
      </a-row>
      <!-- <a-row class="rowStyle">
        <a-col :span="2" class="content_col"><b>对应大额申请单:</b></a-col>
        <a-col :span="16" class="onClickStyle">
          <a-table
              :data-source="decimalDetailList"
              :columns="decimalDetailColumns"
              :pagination="false"
              :rowKey="(record,index)=>{return index}"
              size="small"
              bordered
            ><a-table>
        </a-col>
      </a-row>-->
      <a-row class="rowStyle">
        <a-col :span="2" class="content_col">
          <b>附件列表:</b>
        </a-col>
        <a-col :span="20">
          <upload-attachment
            v-if="formData.fileIds"
            ref="uploadRef"
            :upload-if="false"
            :upload-if-no="false"
          />
          <span v-else>暂无附件</span>
        </a-col>
      </a-row>
    </div>
    <copy-drawer
      ref="publicDrawerRef"
      :title="publicDrawer.title"
      :dialog-visible="publicDrawer.visible"
      :component-name="publicDrawer.comName"
      @projectChanges="projectChanges"
      @close="publicDrawerClose"
    />
  </div>
</template>

<script>
import { dealBigMoney } from '@/utils/common'
import uploadAttachment from '../../common/Upload.vue'
import auditProcessVue from '@/views/common/auditProcess.vue'
import copyDrawer from '../../../components/drawer/copyDrawer.vue'

export default {
  components: { uploadAttachment, auditProcessVue, copyDrawer },
  provide () {
    return {
      formData: this
    }
  },
  data () {
    return {
      formData: {},
      tableDataSource: [],
      tableColumns: [
        {
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: '5%'
        },
        {
          width: '15%',
          title: '费用日期',
          align: 'center',
          dataIndex: 'costDate'
        },
        {
          width: '20%',
          title: '费用类别',
          dataIndex: 'costType',
          scopedSlots: { customRender: 'costType' },
          align: 'center'
        },
        {
          title: '用途',
          dataIndex: 'purpose',
          align: 'center',
          width: '20%'
        },
        {
          width: '20%',
          title: '金额',
          dataIndex: 'amount',
          align: 'center',
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '对应大额申请单号',
          dataIndex: 'bigAmountId',
          scopedSlots: { customRender: 'bigAmountId' },
          align: 'center',
          width: '20%'
        }
      ],
      invoiceDataSource: [],
      invoiceColumns: [
        {
          title: '发票名称',
          dataIndex: 'fileName',
          scopedSlots: { customRender: 'fileName' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '开票日期',
          dataIndex: 'invoiceDate',
          // scopedSlots: { customRender: 'invoiceDate' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '发票代码',
          dataIndex: 'invoiceCode',
          // scopedSlots: { customRender: 'invoiceCode' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '发票号码',
          dataIndex: 'invoiceNumber',
          // scopedSlots: { customRender: 'invoiceNumber' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '合计金额',
          dataIndex: 'money',
          scopedSlots: { customRender: 'money' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '发票校验码',
          dataIndex: 'invoiceCheckCode',
          ellipsis: true,
          // scopedSlots: { customRender: 'invoiceCheckCode' },
          align: 'center'
        }
      ],
      historyCheck: [],
      dutyPersonObj: {},
      checkData: {
        step1: '',
        step2: '',
        step3: '',
        step4: '',
        step5: ''
      },
      auditProcess: '',
      checkList: [],
      decimalDetailList: [],
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      },
      costTypeObj: {},
      costTypeList: [],
      baseURL: this.$baseURL
    }
  },
  mounted () {
    this.dutyPersonObj = this.$store.state.account.dictData.projectPersonObj
    this.costTypeList = this.$store.state.account.dictData.paymentMethodList // 费用类别
    this.costTypeObj = this.$store.state.account.dictData.costTypeObj
    this.$emit('onClickView')
  },
  methods: {
    dealBigMoney,
    setFormData (rowVal, val) {
      this.$get('/reimbursement/getById', { id: rowVal.id }).then(res => {
        if (res.data.status === 1) {
          let data = res.data.data
          this.$nextTick(() => {
            this.formData = { ...data }
          })
          this.getData(data)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    isProject (value, name) {
      // this.$emit('projectChange', value)
      // console.log(value, name)
      this.$emit('projectChange', value, name)
    },
    getData (rowVal) { // 获取其他信息
      this.tableDataSource = rowVal.decimalDetailList
      this.invoiceDataSource = rowVal.invoiceList
      if (rowVal.fileIds) {
        // string 转 数组  循环获取附件信息
        let fileList = rowVal.fileIds.split(',')
        this.$nextTick(() => {
          this.$refs.uploadRef.getFile(fileList)
        })
      }
      this.$nextTick(() => {
        this.$refs.auditRef.getData(rowVal.id, rowVal.checkStatus, 0)
      })
    },
    ClickExProt () {
      this.$download('reimbursement/export', { id: this.formData.id }, `${this.formData.peopleName}-${this.formData.reimbursementDate}的${this.$tree([], 'financialManage/expenseReim/index')}单.xlsx`)
    },
    goBigamount (row) {
      // this.$router.push({path: '/financialManage/largeAmountApplication', query: {id: row.bigamountId}})
      this.getById({ id: row.bigamountId })
    },
    getById (params = {}) {
      this.$get('/bigAmount/byId', params).then(res => {
        if (res.data.status === 1) {
          // this.$emit('largeOrExpenseChange', res.data.data, 'financialManage/largeAmountApplication/show.vue', this.$tree([], 'financialManage/largeAmountApplication/index'))
          this.$emit('datasChange', res.data.data, 'financialManage/largeAmountApplication/show.vue', this.$tree([], 'financialManage/largeAmountApplication/index'))
          // 展开抽屉
          // this.publicDrawer.title = '大额申请'
          // this.publicDrawer.comName = 'financialManage/largeAmountApplication/show.vue'
          // this.publicDrawer.visible = true
          // this.$nextTick(() => {
          //   this.$refs.publicDrawerRef.setForm(res.data.data)
          // })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    publicDrawerClose () { // 公共抽屉关闭
      this.publicDrawer = {
        title: '',
        visible: false,
        comName: ''
      }
    },
    projectChanges (value, name) {
      // this.publicDrawer.visible = false
      if (name === 'project') {
        this.$get('/project/list', { id: value.projectId }).then(res => {
          // this.projectInfo = res.data.data.rows[0]
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.openView(res.data.data.rows[0], 'project')
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        })
      }
      if (name === 'customerName') this.openView(value, name)
      if (name === 'purchaseName') this.openView(value, name)
      if (name === 'contractName') this.openView(value, name)
    }
  }
}
</script>

<style lang="less" scoped>
.titleText {
  text-align: center;
  font-size: 22px;
  font-weight: bolder;
  letter-spacing: 4px;
  position: relative;
}
.sumDiv {
  height: 40px;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px dashed #ccc;
}
.sumTitle {
  font-weight: 500;
  font-size: 14px;
}

.checkDetailsDiv {
  padding: 10px 0;
  border-bottom: 1px dashed #ccc;
  display: flex;
  justify-content: space-around;
}
.rowStyle {
  padding: 10px 0;
  border-bottom: 1px dashed #ccc;
  .content_col {
    width: 150px !important;
    text-align: right;
    margin-right: 10px;
  }
}
.dy {
  position: absolute;
  right: 0;
  top: 0;
  border: 1px solid #ccc;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}
.dy:hover {
  border: 1px solid #2eabff;
  color: #2eabff;
}
</style>



// WEBPACK FOOTER //
// src/views/financialManage/expenseReim/show.vue